<template>
  <div class="home_wrap">
    <van-nav-bar :title="title" left-text="" left-arrow :fixed="true" @click-left="onClickLeft" />
    <div class="art" v-if="!signShow">
      <img v-if="artNumb == 0" style="margin-top:1rem" src="../../assets/images/act/art2.png" alt="">
      <img v-if="artNumb == 1" style="margin-top:1rem" src="../../assets/images/act/art4.png" alt="">
      <img v-if="artNumb == 2" style="margin-top:1rem" src="../../assets/images/act/art5.png" alt="">
      <img v-if="artNumb == 3" src="../../assets/images/act/art6.png" alt="">
      <div v-show="artNumb == 0 || artNumb == 1">
        <div class="artTip" v-if="Number(money) > 0">
          <div>{{ $t("收到的奖励") }}: {{ money }} </div>
          <div class="artButton" @click="receberData">receber</div>
        </div>
        <div class="artTip" style="left:0.1rem" v-else>
          <div>{{ $t("目前没有可用奖励") }}</div>
        </div>
      </div>
    </div>
    <div class="sign-box" v-else>
      <div class="sign-title">
        <div><span>{{ $t('已登录') }} </span><span class="textcolor1">{{ signData.days }}</span><span> {{ $t('连续天数')
            }}</span></div>
        <div> <span>Recarga de hoje </span><span class="textcolor1">{{ signData.recharge_money }} / {{
          signData.min_recharge_money }} </span></div>
      </div>
      <div class="sign-content">
        <div class="table">
          <table>
            <thead>
              <tr>
                <th>
                  <span>{{ $t('时间') }}</span>
                </th>
                <th>
                  <span>{{ $t('奖金') }}</span>
                </th>
              </tr>
            </thead>
            <tbody class="zebra">
              <tr v-for="(item, index) in signData.list">
                <td>{{ item.title }}</td>
                <td>R$ {{ item.money }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="sign-text">
        <div class="sign-text-title">{{ $t('活动说明：') }}</div>
        <div>
          {{ $t('活动说明1') }}
          <br>
          {{ $t('活动说明2') }}
          <br>
          {{ $t('活动说明3') }}
          <br>
          {{ $t('活动说明4') }}
          <br>
          {{ $t('活动说明5') }}
          <br>
          {{ $t('活动说明6') }}
          <br>
          {{ $t('活动说明7') }}
          <br>
        </div>
      </div>
      <div class="sign-bottom-btn">
        <div class="btn" :class="signData.is_signin == 0 ? 'disBtn' : ''" @click="sign()">Entrar</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { NavBar } from "vant";
Vue.use(NavBar);
export default {
  name: "articleContent",
  components: {},
  data() {
    return {
      signShow: false,
      content: "",
      title: "",
      artNumb: null,
      show: true,
      type: 1,
      money: 0,
      status: 0,
      typeParam: '',
      signData: {}
    };
  },
  created() {
    this.$watch('$route', () => {
      this.loadData(); // 监听路由变化，重新加载数据
    });
  },
  beforeDestroy() { },
  mounted() {
    let data = this.$route.query;
    if (data) {
      if (!data.signShow) {
        this.signShow = false;
        this.$parent.act_active = this.$route.query.index;
        this.$parent.changeAct(this.$route.query.index);
        if (this.$route.query.index == 1) {
          this.artNumb = 2;
          this.title = ''
          this.type = 0;
          this.getData(this.type);
        } else if (this.$route.query.index == 3) {
          this.artNumb = 1;
          this.type = 3;
          this.title = this.$t("PG投注奖金");
          this.getData(this.type);
        } else if (this.$route.query.index == 4) {
          this.artNumb = 0;
          this.title = '';
          this.type = 1;
          this.getData(this.type);
        } else if (this.$route.query.index == 5) {
          this.artNumb = 3;
          this.title = ''
        }
      } else {
        this.signShow = true;
        this.$parent.changeAct(this.$route.query.index);
        this.getSign();
        if (this.$route.query.index == 6) {
          this.title = this.$t("连续充值登录奖励");
        }
      }

    }
  },
  methods: {
    onClickLeft() {
      this.$router.push("/activity");
    },
    loadData() {
      window.location.reload();
    },
    getData(type) {
      if (type == 1) {
        this.typeParam = "loss_bonus"
      } else {
        this.typeParam = "pg_bet_bonus"
      }
      Fetch("/record/detail", {
        type: this.typeParam
      }, { method: "get" }).then(res => {
        // if(res)
        if (res.data) {
          this.money = res.data.amount;
          console.log(this.money)
          this.status = res.data.status;
        } else {
        }
      })
    },
    sign() {
      if (this.signData.is_signin == 0) {
        return;
      }
      Fetch("/activity/signin", {
      }).then(res => {
        if (res.data) {
          this.signData = res.data;
        }
      })
    },
    getSign() {
      Fetch("/activity/siginConfig", {
        name: "signin_bonus"
      }, { method: 'get' }).then(res => {
        this.signData = res.data;
        if (res.data.status == 0) {
          this.$parent.activ_list = [{
            name: this.$t('邀请宝箱活动')
          },
          {
            name: ''
          },
          {
            name: ''
          },
          {
            name: this.$t('PG投注奖金')
          },
          {

            name: ''
          },
          {
            name: ''

          },]
        }
      })
    },
    receberData() {
      Fetch("/record/receive", {
        type: this.typeParam
      }).then(res => {
        if (res.code == 1) {
          this.loadData();
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @secondary-color;

}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

.home_wrap {
  background-color: @activityColor;
  padding-bottom: 1rem;
}

.art {
  width: 100%;
  padding: 0.2rem;
  box-sizing: border-box;
  margin-top: 1rem;
  margin-bottom: 1rem;
  position: relative;

  img {
    width: 9.8rem;
  }
}

.sign-box {
  width: 100%;
  // padding: 0.2rem;
  box-sizing: border-box;
  margin-top: 1rem;
  // margin-bottom: 2rem;
  position: relative;
  background-color: @activityColor;
  padding-top: .5rem;

  .sign-title {
    width: 93%;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    background-color: @primary-color;
    color: @textcolor6;
    padding: .2rem;
    border-radius: .2rem;
    font-size: .25rem;


    .textcolor1 {
      color: @textcolor1;
    }
  }

  .sign-content {
    width: 93%;
    margin: 0 auto;
    margin-top: .3rem;
    padding: .3rem;
    box-sizing: border-box;
    background-color: @primary-color;
    border-radius: .2rem;


    .table {
      color: @textcolor6;

      table {
        width: 100%;
        border-collapse: collapse;
        border-radius: .375rem;
        border: none;
        font-size: .4rem;

        // font-weight: 400!important;
        th {
          background-color: @activityColor;
          border-bottom: 1px solid @bodercolor !important;
          border-top: 1px solid @bodercolor !important;
          font-weight: 400;
          font-size: .35rem;
          word-wrap: break-word;
          transition: background .3s ease;
          padding: 0;
          height: 1.3rem;
          color: @textcolor1;
        }

        th:first-child {
          border-left: .1px solid @bodercolor !important;
        }

        th:last-child {
          border-right: .1px solid @bodercolor !important;
        }

        .zebra tr:nth-child(odd) {
          background-color: unset !important;
          font-size: .32rem;
          // border-radius: var(--theme-tr-border-radius);
        }

        .zebra tr:nth-child(even) {
          background-color: @activityColor !important;
          font-size: .32rem;
        }

        tr {
          height: 1.2rem;
          text-align: center;

        }
      }
    }
  }

  .sign-text {
    width: 93%;
    margin: 0 auto;
    padding: .2rem;
    box-sizing: border-box;
    color: @textcolor3;
    background-color: @primary-color;
    border-radius: .2rem;
    margin-top: .3rem;
    font-size: .28rem;
    line-height: .5rem;
  }

  .sign-bottom-btn {
    width: 100%;
    background-color: @primary-color;
    position: relative;
    box-sizing: border-box;
    padding-top: .2rem;
    margin-top: .5rem;
    // margin-bottom: .5rem;
    padding-bottom: .2rem;
    position: fixed;
    left: 50% !important;
    right: unset !important;
    top: unset !important;
    bottom: 0 !important;
    transform: translate(-50%) !important;
    max-width: @maxWidth;
    z-index: 10;

    .btn {
      width: 90%;
      text-align: center;
      background-color: @ButtonColor;
      margin: 0 auto;
      padding: .3rem .2rem;
      box-sizing: border-box;
      border-radius: .2rem;
      color: #fff;
    }

    .disBtn {
      background-color: @disableColor;
    }
  }
}

.artTip {
  position: absolute;
  top: 0.5rem;
  left: 0.7rem;
  color: #fff;
  font-size: .38rem;
  // background-color: @primary-color;
  padding: .1rem;
  border-radius: .2rem;
  margin-left: .7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    background-color: @primary-color;
    padding: .2rem;
    border-radius: .2rem;
  }

  .artButton {
    padding: .18rem;
    background-color: @ButtonColor;
    margin-left: 0.5rem;
    flex: 1;
    border-radius: .2rem;
    // color: @textcolor4;
  }
}
</style>